import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { SummonerLookup } from '@/features/accounts/summoner-lookup'

export const Route = createFileRoute('/_authed/accounts/find')({
  component: FindAccountPage,
})

function FindAccountPage() {
  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <div className="flex flex-wrap items-center gap-3">
        <Button variant="ghost" size="sm" asChild>
          <Link to="/accounts">
            <ArrowLeft />
            Accounts
          </Link>
        </Button>
        <h1 className="text-2xl font-semibold">Find an account</h1>
      </div>
      <p className="text-sm text-muted-foreground">
        Look up a Riot ID on the server. An account that is already linked is reported as such.
      </p>
      <SummonerLookup onFound={() => undefined} />
    </div>
  )
}
